import makeQueryKey from "../../../../utils/make-query-key";
import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
var getWishlistQueryKey = function getWishlistQueryKey() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    id = _ref.id;
  var _getWebShellClientLoc = getWebShellClientLocale(),
    country = _getWebShellClientLoc.country,
    marketplaceId = _getWebShellClientLoc.marketplaceId;
  var marketplace = marketplaceId || country.toUpperCase();
  return makeQueryKey(['buy/wishlists/v2', {
    marketplace: marketplace,
    id: id
  }]);
};
export default getWishlistQueryKey;